// src/hooks/useSupabase.ts
import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase, getCurrentSession, onAuth } from "../lib/supabase";

/**
 * Hook ligero para acceder al cliente y a la sesión actual.
 * Útil si alguna vista necesita el user id o metadata sin pasar por props.
 */
export function useSupabase() {
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    let unsub = () => {};
    (async () => {
      setSession(await getCurrentSession());
      unsub = onAuth((_ev, s) => setSession(s));
    })();

    return () => {
      try {
        unsub();
      } catch {
        /* no-op */
      }
    };
  }, []);

  return { supabase, session, user: session?.user ?? null };
}
